import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILine, ILineState } from "./lineModel";
import { createLine, deleteLine, getAllActiveLine, getAllLine, getLineByID, lineActiveInactive, updateLine } from "./services/line.services";

const initialState: ILineState = {
  loading: false,
  formLoading: false,
  error: "",
  LineList: [],
  LineID: null,
  LineDetail: {
    line_name: "",
    description: "",
    isactive: 1,
  },
};

const lineSlice = createSlice({
  name: "line",
  initialState,
  reducers: {
    clearLineDetails: (state) => {
      state.LineDetail = initialState.LineDetail;
    },
    setLineID: (state, action) => {
      state.LineID = action.payload;
    },
    clearLineID: (state) => {
      state.LineID = initialState.LineID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllLine.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
        getAllLine.fulfilled,
      (state, action: PayloadAction<ILine[]>) => {
        state.loading = false;
        state.LineList = action.payload || [];
      }
    );
    builder.addCase(getAllLine.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.LineList = [];
    });
    builder.addCase(getAllActiveLine.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveLine.fulfilled,
      (state, action: PayloadAction<ILine[]>) => {
        state.loading = false;
        state.LineList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveLine.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.LineList = [];
    });
    builder.addCase(createLine.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(createLine.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createLine.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateLine.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateLine.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateLine.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteLine.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteLine.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteLine.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(lineActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(lineActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(lineActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getLineByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getLineByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.LineDetail = action.payload;
    });
    builder.addCase(getLineByID.rejected, (state, action) => {
      state.formLoading = false;
      state.LineDetail = initialState.LineDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearLineDetails, setLineID, clearLineID } =
lineSlice.actions;
export default lineSlice.reducer;
